import { useQueryCache } from "@pinia/colada";
import type { UpdateCustomerDetails } from "@/schemas/customer";

export function useUpdateCustomerDetailsForm(prefix: "billing" | "shipping") {
  const queryCache = useQueryCache();
  const { cart } = useCart();
  return useFormHandler<{ message: string; cart: Cart }, UpdateCustomerDetails>({
    schema: updateCustomerDetailsSchema,
    action: "update_customer_details",
    onSuccess: ({ cart }) => queryCache.setQueryData(["cart"], cart),
    initialValues: computed(() => v.parse(updateCustomerDetailsSchema, { customer_details: cart.value.customer[prefix] })),
  });
}
